import React, { Component } from "react";

import { Line } from "react-chartjs-2";

import Timeline from "@material-ui/icons/Timeline";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import * as api from "core-module/services/api";
import { ApiError } from "../../core-module/services/error";

import "chartjs-plugin-streaming";

async function fastPullRequest(userId) {
  try {
    const response = await api.get(`user.${userId}/cpefastpull.${userId}`);
    return response;
  } catch (e) {
    if (e instanceof ApiError) {
      alert(e.message);
      console.log(e.message);
      return false;
    }
    // else {
    //   alert('Something went wrong. Please try again later.');
    //   setFormErrorMessage('Something went wrong. Please try again later.');
    //   throw e;
    // }
  }
}

class TrafficStreaming extends Component {
  constructor(props) {
    super(props);
    this.chartReference = React.createRef();
    this.state = { userId: props.userId };
  }

  componentDidMount() {
    // console.log(this.chartReference); // returns a Chart.js instance reference
  }

  render() {
    const userId = this.state.userId;
    var prevUploadBits = 0;
    var prevDownloadBits = 0;

    const getData = (canvas) => {
      const ctx = canvas.getContext("2d");
      const blueGradient = ctx.createLinearGradient(0, 500, 0, 0);
      const redGradient = ctx.createLinearGradient(0, 500, 0, 0);
      blueGradient.addColorStop(0, "#43464b");
      blueGradient.addColorStop(1, "#27aae1");
      redGradient.addColorStop(0, "#43464b");
      redGradient.addColorStop(1, "#dd3449");
      return {
        datasets: [
          {
            label: "Download",
            borderColor: "#27aae1",
            backgroundColor: blueGradient,
            fill: true,
            cubicInterpolationMode: "monotone",
            data: [],
          },
          {
            label: "Upload",
            borderColor: "#dd3449",
            fill: true,
            backgroundColor: redGradient,
            cubicInterpolationMode: "monotone",
            data: [],
          },
        ],
      };
    };

    return (
      <Card style={{ backgroundColor: "#43464b" }}>
        <CardHeader color="primary" icon>
          <CardIcon color="primary">
            <Timeline />
          </CardIcon>
          <h4>Live Traffic</h4>
        </CardHeader>
        <CardBody style={{ paddingRight: "0px", paddingLeft: "0px" }}>
          <GridContainer align="center">
            <GridItem xs={12}>
              <div
                style={{
                  backgroundColor: "#43464b",
                  position: "relative",
                  height: this.props.cardHeight,
                }}
              >
                <Line
                  data={getData}
                  options={{
                    elements: {
                      point: {
                        radius: 0,
                      },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    aspectRatio: 0.5,
                    legend: {
                      labels: {
                        fontColor: "white",
                      },
                    },
                    title: {
                      display: false,
                    },
                    scales: {
                      xAxes: [
                        {
                          gridLines: {
                            display: false,
                          },
                          type: "realtime",
                          ticks: {
                            display: false,
                            fontColor: "white",
                          },
                          realtime: {
                            duration: 20000,
                            refresh: 1000,
                            delay: 2000,
                            onRefresh: async function (chart) {
                              var data = await fastPullRequest(userId);
                              if (
                                !data ||
                                !data.object ||
                                !data.object.data.Data ||
                                !data.object.data.Data.ether1
                              ) {
                                return;
                              }
                              var uploadBits =
                                parseInt(
                                  data.object.data.Data.ether1.b.split(",")[0]
                                ) * 8;
                              var downloadBits =
                                parseInt(
                                  data.object.data.Data.ether1.b.split(",")[1]
                                ) * 8;

                              if (
                                prevUploadBits !== 0 &&
                                prevDownloadBits !== 0
                              ) {
                                const date = Date.now();
                                var uploadMegaBits =
                                  (uploadBits - prevUploadBits) / 1000000;
                                var downloadMegaBits =
                                  (downloadBits - prevDownloadBits) / 1000000;

                                const uploadPoint = {
                                  x: date,
                                  y: uploadMegaBits,
                                };

                                const downloadPoint = {
                                  x: date,
                                  y: downloadMegaBits,
                                };

                                chart.data.datasets[1].data.push(uploadPoint);
                                chart.data.datasets[0].data.push(downloadPoint);

                                // chart.update({
                                //   preservation: true
                                // });
                              }
                              prevUploadBits = uploadBits;
                              prevDownloadBits = downloadBits;
                            },
                          },
                        },
                      ],
                      yAxes: [
                        {
                          scaleLabel: {
                            display: false,
                          },
                          ticks: {
                            fontColor: "white",
                            callback: function (value, index, values) {
                              if (value < 1) {
                                var kilobits = value * 1000;
                                return kilobits + " kb/s";
                              }
                              return value + " mb/s";
                            },
                            lineHeight: 3,
                            fontSize: 13,
                          },
                        },
                      ],
                    },
                    tooltips: {
                      mode: "nearest",
                      intersect: false,
                    },
                    hover: {
                      mode: "nearest",
                      intersect: false,
                    },
                  }}
                />
              </div>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    );
  }
}

export default TrafficStreaming;
